import React from 'react';
import { useAppSelector } from '../../redux/store';

const SidebarHeader: React.FC = () => {
  const organization = useAppSelector(state => state.organization.currentOrganization);
  const hasCompanyLogo = !!organization?.logoUrl;

  return (
    <div className="p-[13px] flex items-center gap-[13px] border-b border-border">
      {/* OMNILAW Logo - shrinks and disappears when sidebar is too narrow */}
      <div className="min-w-0 overflow-hidden transition-all duration-200 flex-shrink">
        <img
          src="/OmniLawLogoTransparentHorizontal.png"
          alt="OmniLaw"
          className="h-16 w-auto object-contain"
        />
      </div>

      {/* Company Logo Badge - Secondary (RTL-aware positioning) */}
      {hasCompanyLogo && (
        <div className="flex-shrink-0 ms-auto">
          <div className="relative group">
            {/* Subtle glow effect */}
            <div className="absolute inset-0 bg-gold/5 rounded-lg blur-sm group-hover:bg-gold/10 transition-colors" />

            {/* Logo container */}
            <div className="relative bg-background/50 border border-border/50 rounded-lg backdrop-blur-sm overflow-hidden">
              <img
                src={organization.logoUrl}
                alt={organization.name}
                className="h-[62px] w-auto max-w-[100px] object-contain"
                onError={(e) => {
                  // Hide if logo fails to load
                  e.currentTarget.parentElement?.parentElement?.remove();
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarHeader;

